import { cva } from "class-variance-authority";

export const appPriceStatusVariants = cva(
  `rounded-lg text-center border-none px-2 py-0.5 duration-300`,
  {
    variants: {
      type: {
        free: "min-w-11 bg-green group-hover:bg-green-hovered text-green-second dark:text-green-800",
        notFree:
          "min-w-20 bg-primary-light dark:bg-blue-300 dark:text-indigo-950 group-hover:bg-primary-blue group-hover:text-primary-hovered text-primary-selected",
      },
    },
  },
);
